import { z } from 'zod';
import { listSearchSchema } from '@/shared/patterns/list-search';
import { userGroupFilters } from './user-group.filters';

export const USER_GROUP_TABS = ['informacoes', 'membros', 'permissoes'] as const;
export type UserGroupTab = (typeof USER_GROUP_TABS)[number];
export const MEMBER_PAGE_SIZE = 10;
export const MEMBER_SHEET = 'novo-membro';

export const userGroupListSearch = listSearchSchema({ ...userGroupFilters.shape });

/** Detalhe: aba, sheet e a página da aba Membros (U39 §2; o legado guardava em estado local). */
export const userGroupDetailSearch = z.object({
  tab: z.enum(USER_GROUP_TABS).optional().catch(undefined),
  sheet: z.string().optional().catch(undefined),
  page: z.coerce.number().int().min(1).optional().catch(undefined),
  size: z.coerce
    .number()
    .int()
    .refine((value) => [5, 10, 15, 20].includes(value))
    .optional()
    .catch(undefined),
});
